import CreditCardsConfiguration from "./CreditCardsConfiguration.component.jsx";

export default CreditCardsConfiguration;
